import { createSlice } from "@reduxjs/toolkit";
import { WHOLE_DATASET_FEED_CHUNK } from "../constants/FeedConsts";

export const dateRangeSlice = createSlice({
  name: "dateRange",
  initialState: {
    startDate: WHOLE_DATASET_FEED_CHUNK.start,
    endDate: WHOLE_DATASET_FEED_CHUNK.end,
    showFilters: false,
    dateRangeSelected: false,
  },
  reducers: {
    updateStartDate: (state, action) => {
      state.startDate = action.payload;
    },
    updateEndDate: (state, action) => {
      state.endDate = action.payload;
    },
    setShowFilters: (state, action) => {
      state.showFilters = action.payload;
    },
    setDateRangeSelected: (state, action) => {
      state.dateRangeSelected = action.payload;
    },
  },
});

export const {
  updateStartDate,
  updateEndDate,
  setShowFilters,
  setDateRangeSelected,
} = dateRangeSlice.actions;

export default dateRangeSlice.reducer;
